import React from 'react'
import styled from 'styled-components'
import { Redirect } from 'react-router-dom'
import { withApollo } from 'react-apollo'
import { message, Row, Col } from 'antd'
import moment from 'moment';
import OtpInput from 'react-otp-input';
import Step1 from './detail/step1'
import Step2 from './detail/step2'
import Step3 from './detail/step3'
import Step4 from './detail/step4'
// import Step2 from '../../../components/user/FormForgetpassword/Step2'
import { ErrorMessageFormAPIApollo } from '../../../utils/checkError'
import { setToken, isLoggedIn, getLsId, getOrganization } from '../../../utils/auth'
import { Mutations, Queries } from '../../../graphql'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'
import FooterLogin from '../../../components/user/FooterLogin'

const BackgroundDiv = styled.div`
	// height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
`

const FormDiv = styled.div`
	padding: 50px 100px;
	box-shadow: 30px 40px 40px 1px rgba(0, 0, 0, 0.15), 0 0px 0px rgba(0, 0, 0, 0.25);
	border-radius 20px;
	background-color: #fff;
`

class Confirm extends React.PureComponent {
	state = {
		confirmpassword: 1,
		verificationCode: "",
		citizenId: "",
		employeeCode: "",
		birthDate: "",
		gender: "",
		firstName: "-",
		lastName: "-",
		positionName: "-",
		orgUnitName: "-",
		consent: true,
		policy: "",
		consent: false,
		showModal: false,
		verificationCode: "",
		//////////////////////addmodalINTERNAL_SERVER_ERROR
		showModalErrors: false,
		otpToSead: {}
	}
	onSubmit = async values => {
		// console.log("values.verificationCode,values.citizenId,getLsId(),moment(values.birthDate).format('YYYY-MM-DD'),getOrganization()", values.verificationCode, values.citizenId, getLsId(), moment(values.birthDate).format('YYYY-MM-DD'), getOrganization());

		await this.setState({
			// confirmpassword: 2,
			citizenId: values.citizenId,
			birthDate: moment(values.birthDate).format('YYYY-MM-DD'),
		});
		// console.log("values.citizenId,getLsId() ,moment(values.birthDate).format('YYYY-MM-DD'),getOrganization()" ,values.citizenId,getLsId() ,moment(values.birthDate).format('YYYY-MM-DD'),getOrganization());

		try {
			const { client } = this.props
			const { data, errors } = await client.query({
				query: Queries.forgetPassword,
				variables: {
					identityCard: values.citizenId,
					lsid: getLsId(),
					birthDate: moment(values.birthDate).format('YYYY-MM-DD'),
					organization: getOrganization(),
					requestFor: "FORGET_PASSWORD",
				}
			})
			//////////////////////addmodalINTERNAL_SERVER_ERROR
			if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
				await this.setState({
					showModalErrors: true
				})
			}
			else if (errors) {
				// message.error(ErrorMessageFormAPIApollo(errors[0]))
			}

			if (errors) {
				// message.error("กรุณากรอกข้อมูลให้ถูกต้อง")
				// console.log("null");
			}
			if (data.forgetPassword) {
				if (data.forgetPassword.status == true) {
					await this.setState({ confirmpassword: 2 })
				}
			}
		} catch (error) {
			console.log(error)
		}
	}

	onSubmit2 = async (value) => {
		console.log("lsid", getLsId(), 'dentityCard', this.state.citizenId, "birthDate", moment(this.state.birthDate).format('YYYY-MM-DD'), "organization", getOrganization(), "verificationCode", value);
		await this.setState({ verificationCode: value })
		try {
			const { client } = this.props
			const { data, errors } = await client.query({
				query: Queries.checkSMSforgetPassword,
				variables: {
					lsid: getLsId(),
					identityCard: this.state.citizenId,
					birthDate: moment(this.state.birthDate).format('YYYY-MM-DD'),
					organization: getOrganization(),
					verificationCode: this.state.verificationCode,
					// verificationCode: value,
				}
			})
			// console.log("data : ", data.checkSMSforgetPassword);
			//////////////////////addmodalINTERNAL_SERVER_ERROR
			if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
				await this.setState({
					showModalErrors: true
				})
			}
			else if (errors) {
				// message.error(ErrorMessageFormAPIApollo(errors[0]))
			}
			else {
				await this.setState({
					firstName: data.checkSMSforgetPassword.firstName,
					lastName: data.checkSMSforgetPassword.lastName,
					positionName: data.checkSMSforgetPassword.employee.workingProfile.orgPosition.positionName,
					orgUnitName: data.checkSMSforgetPassword.employee.workingProfile.orgUnit.orgUnitName,
					gender: data.checkSMSforgetPassword.gender,
					confirmpassword: 3
				});
			}
		} catch (error) {
			// console.log("error checkSMSforgetPassword",error)
			// const errorMessage = error.graphQLErrors[0].message
			// message.error(ErrorMessageFormAPIApollo(errorMessage))
		}
		// await this.setState({
		// 	confirmpassword: 3
		// });

	}

	onSubmit3 = async (value) => {
		console.log(value);
		try {
			const { client } = this.props
			const { data, errors } = await client.query({
				query: Mutations.resetPassword,
				variables: {
					lsid: getLsId(),
					identityCard: this.state.citizenId,
					verificationCode: this.state.verificationCode,
					birthDate: moment(this.state.birthDate).format('YYYY-MM-DD'),
					organization: getOrganization(),
					password: value.password,
					confirmPassword: value.confirmpassword,
					// verificationCode: value,
				}
			})
			console.log("data : ", data.resetPassword);
			//////////////////////addmodalINTERNAL_SERVER_ERROR
			if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
				await this.setState({
					showModalErrors: true
				})
			}
			else if (errors) {
				// if(errors[0].extensions.code == 'PASSWORD_DOESNT_MATCH'){
				// 	message.error(ErrorMessageFormAPIApollo(errors[0]))
				// }
			}
			else {
				if(data){
					message.success('ทำการเปลี่ยนรหัสผ่านเรียบร้อย');
					setTimeout(() => {
						window.location.href = '/login'
					}, 1000);
				}
				
			}
		} catch (error) {
			// console.log(error)
			// const errorMessage = error.graphQLErrors[0].message
			// message.error(ErrorMessageFormAPIApollo(errorMessage))
		}
	}


	showModal() {
		this.setState({ showModal: true })
	}

	switchShowPage = async (page, otpData = {})=>{
      if(page == 4){
         this.props.changeShowFooter(false)
      }
		await this.setState({
			confirmpassword: page,
			otpToSead: otpData
		})

      console.log("otpToSead", this.state.otpToSead ) 
	}

	handleOk = () => {
		this.setState({
			showModal: false,
			consent: true,
			confirmpassword: 2
		});
	};

	handleCancel = () => {
		this.setState({ showModal: false });
	};


	render() {
		const { confirmpassword, firstName, lastName, positionName, gender, orgUnitName } = this.state
		if (isLoggedIn()) {
			return <Redirect to="/" />
		}

		return (
			<Row>
				<Col>
					{
						confirmpassword == 1 &&
						<Step1
							autoFocus
							policy={this.state.policy}
							afterSubmit={this.onSubmit}
							handleOk={this.handleOk}
							handleCancel={this.handleCancel}
							showModal={this.state.showModal}
							switchShowPage={this.switchShowPage}
                     dataProfileSSO={this.props.dataProfileSSO}
						/>
					}
					{
						confirmpassword == 2 &&
						<Step2
							autoFocus
							policy={this.state.policy}
							afterSubmit={this.onSubmit}
							handleOk={this.handleOk}
							handleCancel={this.handleCancel}
							showModal={this.state.showModal}
							otpToSead={this.state.otpToSead}
							switchShowPage={this.switchShowPage}
                     dataProfileSSO={this.props.dataProfileSSO}
						/>
					}

					{
						confirmpassword == 3 &&
						<Step3
							autoFocus
							switchShowPage={this.switchShowPage}
							otpToSead={this.state.otpToSead}
							dataProfileSSO={this.props.dataProfileSSO}
						/>
					}
					{
						confirmpassword == 4 &&
						<Step4
							autoFocus
							switchShowPage={this.switchShowPage}
							otpToSead={this.state.otpToSead}
							dataProfileSSO={this.props.dataProfileSSO}
							onSwitchMainPage={this.props.onSwitchMainPage}
                     pageChangePassword='noAuth'
						/>
					}
				</Col>
			</Row>
		)
	}
}

export default withApollo(Confirm)